import S from 'common/service/sanctuary';
import { map, filter } from 'rxjs/operators';
import { scopedType } from '../scope/type';

const factory$ = (namespace, epic) => (source, ...rest) => {
  const sink = S.pipe([
    map(action => S.map(
      type => ({
        ...action,
        type,
      }),
      S.stripPrefix(scopedType(namespace, ''), action.type),
    )),
    filter(m => m.isJust),
    map(m => S.maybeToNullable(m)),
  ], source);

  return S.pipe([
    map(action => ({
      ...action,
      type: scopedType(namespace, action.type),
    })),
  ], epic(sink, ...rest));
};

export const factory = S.curry2(factory$);

export default factory;
